export default "__VITE_ASSET__3INYsTFn__"